import { isUrn, safeParseURN } from "./urn.ts";

/**
 * The file card's page URL, absolute or rooted, as the email absolutizer used
 * to rewrite a file URN to — and as the agent then learned to write (BIG-8463).
 * Documents and drafts from before the fix still carry it, so it is read as the
 * file it named rather than left as a request for an HTML page.
 *
 * The absolute form is matched only on the origins the absolutizer could have
 * written — each deploy's `PUBLIC_URL`. Any other host serving that path is
 * somebody else's picture, and reading it as a file id would swap it for an
 * unrelated local file. The list is closed: nothing writes this form any more.
 */
const FILE_PAGE_URL_RE =
  /^(?:https:\/\/app\.(?:okthx|bigbasinlabs)\.com|http:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?)?\/artifacts\/file\/(\d+)$/;

/**
 * The file artifact an image `src` names, or null when it names none.
 *
 * The one grammar for it: both clients render with it, and the server reads it
 * to decide which files a shared document lets its readers see. Kept in one
 * place because a server that honoured a `src` the clients do not render as
 * that file would grant reach to a picture no reader is shown.
 */
export const fileArtifactIdFromImageSrc = (src: string): string | null => {
  if (src.startsWith("urn:")) {
    const urn = safeParseURN(src);
    return urn?.type === "file" && isUrn(src) ? urn.id : null;
  }
  return FILE_PAGE_URL_RE.exec(src)?.[1] ?? null;
};
